import React, { useState } from "react";
import "../../assets/css/sign.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../../assets/AdityaBirlaGroupLogoVector.svg";
import mainBanner from "../../assets/MainBanner.svg";
import { useNavigate } from "react-router-dom";

import Loader from "../../Components/LoaderAndSpinner/Loader";

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({})
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      const formData = {
        email,
        otp,
        newPassword,
        confirmPassword,
      };



      const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      // Log the response status

      if (!response.ok) {
        const errorData = await response.json();


        const errorMessaged = errorData.message

        setErrors(errorData.errors || {});
        toast.error(errorMessaged);

        setLoading(false);
        return
      }

      // const responseData =
      await response.json(); // Parse response data

      navigate("/auth/login");

    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("Error occurred")
      setLoading(false);
    }

    setLoading(false);
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="container  bg-white">
        <div>
          <div className="row signIn-card">
            <div className="col-lg-6 p-0 pt-4 col-md-12 px-4  mb-4 resp-img">
              <img src={mainBanner} alt="bg-image " className="resp-img-img" />
              <img src={logo} className="banner-logo desktop-logo" />
              <div className="banner-text-container">
                <h1 className="banner-text1">Asset Taxonomy Management</h1>
                <h3 className="banner-text2">ATM - version 1.0</h3>
              </div>
            </div>
            <div className="col-lg-6 col-md-12  p-0 px-4 signin-col align-content-center ">
              <h2>Change Password</h2>
              <p>Enter your details to sign in to your account</p>
              <form className="signin-form needs-validation" onSubmit={handleSubmit} noValidate>
                <div
                  className="d-flex flex-column"
                  style={{ marginBottom: "16px", position: "relative" }}
                >
                  <label htmlFor="email" className="signin-form-label">
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className={`signin-form-input ${errors.email ? "is-invalid" : ""
                      }`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    autoComplete="off"
                  />
                  {errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>

                <div
                  className="d-flex flex-column"
                  style={{ marginBottom: "16px", position: "relative" }}
                >
                  <label htmlFor="otp" className="signin-form-label">
                    OTP
                  </label>
                  <input
                    id="otp"
                    name="otp"
                    type="text"
                    className={`signin-form-input ${errors.otp ? "is-invalid" : ""
                      }`}
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter OTP"
                  />
                  {errors.otp && (
                    <div className="invalid-feedback">{errors.otp}</div>
                  )}
                </div>

                <div
                  className="d-flex flex-column"
                  style={{ marginBottom: "16px", position: "relative" }}
                >
                  <label htmlFor="newPassword" className="signin-form-label">
                    New Password
                  </label>
                  <input
                    id="newPassword"
                    name="newPassword"
                    type="password"
                    className={`signin-form-input ${errors.newPassword ? "is-invalid" : ""
                      }`}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                  />
                  {errors.newPassword && (
                    <div className="invalid-feedback">
                      {errors.newPassword}
                    </div>
                  )}
                </div>

                <div
                  className="d-flex flex-column"
                  style={{ marginBottom: "16px", position: "relative" }}
                >
                  <label
                    htmlFor="confirmPassword"
                    className="signin-form-label"
                  >
                    Confirm New Password
                  </label>
                  <input
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    className={`signin-form-input ${errors.confirmPassword ? "is-invalid" : ""
                      }`}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                  />
                  {errors.confirmPassword && (
                    <div className="invalid-feedback">
                      {errors.confirmPassword}
                    </div>
                  )}
                </div>

                <button type="submit" className="signin-form-button">
                  SUBMIT
                </button>
              </form>
            </div>
          </div>
          <div className="d-flex justify-content-between align-content-center  px-4  sign-footer-text">
            <p className="w-100">Copyright all rights reserved {currentYear}</p>
            <div className="w-100 d-flex gap-5 justify-content-end sign-footer-text-1 ">
              <p>Terms Of Use</p>
              <p>Privacy Policy</p>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer autoClose={4000} position={"top-right"} />
    </>
  );
};

export default ChangePassword;
